import React, {useState} from 'react';
import {PlusLg} from "react-bootstrap-icons";
import {Button} from "fearless-common-ui";
import Modal from "react-bootstrap/Modal";
import GroupCreate from "../../pages/partials/GroupCreate";
import {concepts} from "fearless-common";
import {useSearchParams} from "react-router-dom";

/**
 * Button and modal to create a new group.
 */
export default function NewGroupButtonAndModal({ onSuccess }: { onSuccess: (resp: { data: { id: number }}) => void }) {
    const [sp] = useSearchParams()
    const [modalOpen, setModalOpen] = useState<boolean>(Boolean(sp.get('open_create_modal')));
    return (
        <>
            <div className="d-flex justify-content-start">
                <Button
                    dataTestId="add-group-button"
                    onClick={() => setModalOpen(true)}
                    variant="outline-primary"
                    size="sm"
                >
                    <PlusLg />
                    add {concepts.Group.toLowerCase()}
                </Button>
            </div>
            {modalOpen && (
                <Modal show={modalOpen} onHide={() => setModalOpen(false)}>
                    <Modal.Header closeButton>&nbsp;</Modal.Header>
                    <Modal.Body>
                        <GroupCreate
                            onSuccess={(resp: { data: { id: number }}) => {
                                onSuccess(resp);
                                setModalOpen(false);
                            }}
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
}
